export const descriptionData = [
    {
        title: "Dashboard",
        data: [
            "Shows sales, returns with saleable & non saleable(100%) & net sales figures",
            "Shows month to current date (MTD) sales, todays sales, target & PRPM",
            "Shows comparision of current month MTD sales with last month MTD sale & last year same month MTD sale",
            "Shows your target achievement for the current month",
            "Shows top 5 growth & top 5 degrowth products of the current month ",
            "Shows top 5 growth & top 5 degrowth territories of the current month",
            "Shows top 5 selling products"
        ]
    },
    {
        title: "Projection - Divisionwise",
        data: [
            "Feature to adjust target using slider for projected sales",
            "Shows month to current date(MTD) sales",
            "Shows division contribution % towards sale",
            "Shows projected value as per target contribution %",
            "Show shortfall as per current sale and target"
        ]
    }, {
        title: "Projection - Regionwise",
        data: [
            "Region wise target, last year same month MTD sale, month to current date (MTD) sales",
            "Shows region commitment for comparision"
        ]
    }, {
        title: "Sales Data",
        data: [
            "Shows Division, Region, Area, Territory & customer Sales as per mapping",
            "Shows month to current date(MTD) sales, last month MTD sale, last year same month MTD sale, target, PRPM,PSO count as per mapping",
            "Shows comparision of current month MTD sales with last year same month MTD sale",
            "Click on sale value button 000.00 to further drill in Region, area, territory & customer sales figures.",
            "Shows Returns of Division, Region, Area, Territory & customer Sales as per mapping",
            "Click on Click on excel image to download data in excel format"
        ]
    }, {
        title: "CNF sales division wise available for corporate employees",
        data: []
    }, {
        title: "Brand Wise Sales",
        data: [
            "Shows Brand wise, Region, Area, Territory Sales as per mapping",
            "Click on sale value button 000.00 to further drill in product wise, Region, area, territory",
            "Option to filter data territory wise",
            "Click on Click on excel image to download data in excel format",
            "Shows brand wise, product wise returns of Division, Region, Area, Territory & customer Sales as per mapping"
        ]
    }, {
        title: "Product Stock",
        data: [
            "Shows Product wise saleable, non-saleable, in transit & hold stock",
            "Shows stock in transit dates",
            "Click on Click on excel image to download data in excel format"
        ]
    }, {
        title: "DC Register",
        data: [
            "Shows Customer wise, Item wise & invoice wise customer sales details",
            "Click on sales value button 000.00 to further drill in item summary & invoice details",
            "Export button available to download data in excel format"
        ]
    }, {
        title: "Provisional Statement",
        data: ["Shows brandwise/product wise provisional statement",
            "Shows data from April to current period with Last year sales & growth figures",
            "Export button available to download data in excel format"]
    }, {
        title: "Onward Dispatch Details",
        data: ["Shows summary of territory wise/brand wise onward dispatch quantity.",
            "Shows entire onward dispatch details territory wise / brand wise",
            "Export button available to download data in excel format"]
    }];
